import { ChangeEvent, FC, useCallback } from 'react';
import { ShowMore } from '@ebsco-ui/ebsco-ui';

import { FacetKey, MappedFacetValues, ShowMoreButton } from '@app/components';
import { useSearchContext } from '@app/contexts';

import { useFilterPanelContext } from '../../FilterPanelContext';
import { FacetAttribute } from '../../FacetAttribute';
import { facetAttributesLimit } from '../../constants';

import css from '../Facet.module.scss';

interface FacetShowMoreProps {
  values: MappedFacetValues;
  facetKey: FacetKey;
  limit?: number;
}

export const FacetAttributes: FC<FacetShowMoreProps> = ({
  values = [],
  facetKey,
  limit = facetAttributesLimit,
}) => {
  const { toggleFacetAttribute } = useFilterPanelContext();
  const { activeFacets } = useSearchContext();

  const isFacetAttributeActive = useCallback(
    (facetKey, value) => Boolean(activeFacets[facetKey]?.[value]),
    [activeFacets]
  );

  if (!values) {
    return null;
  }

  return (
    <fieldset>
      <ShowMore limit={limit}>
        <ShowMore.Items>
          {values.map(({ label, value, count }) => (
            <FacetAttribute
              key={`${facetKey}-${value}`}
              facetKey={facetKey}
              label={label}
              value={value}
              activeAttributesCount={count}
              isActive={isFacetAttributeActive(facetKey, value)}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                toggleFacetAttribute(facetKey, event.target.value)
              }
            />
          ))}
        </ShowMore.Items>
        <div key="toggle-row" className="facet-attribute">
          <ShowMoreButton
            showMoreLimit={limit}
            dataLength={values.length}
            className={css.showMoreButton}
          />
        </div>
      </ShowMore>
    </fieldset>
  );
};
